import Navbar from './components/Navbar';
import Hero from './components/Hero';
import VisualGrid from './components/VisualGrid';
import FeaturedIn from './components/FeaturedIn';
import Testimonials from './components/Testimonials';
import TestimonialsCTA from './components/TestimonialsCTA';
import HonorsSection from './components/HonorsSection';
import MembershipTiers from './components/MembershipTiers';
import FAQ from './components/FAQ';
import LearningSystem from './components/LearningSystem';
import PersonalTutoring from './components/PersonalTutoring';
import FreeSection from './components/FreeSection';
import BooksSection from './components/BooksSection';
import TutoringForm from './components/TutoringForm';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';
import FloatingBookButton from './components/FloatingBookButton';
import SEOHead from '../../components/SEOHead';

export default function Home() {
  const siteUrl = (import.meta.env.VITE_SITE_URL as string) || 'https://example.com';

  const jsonLd = [
    {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: 'Augustine Math Mastery',
      url: siteUrl,
      potentialAction: {
        '@type': 'SearchAction',
        target: `${siteUrl}/grades?q={search_term_string}`,
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'EducationalOrganization',
      name: 'Augustine Math Mastery',
      description:
        'Comprehensive K-12 mathematics education, SAT/ACT test prep, AP Calculus, and personalized tutoring by award-winning NYC teacher Augustine Anyimadu-Ahenkae.',
      url: siteUrl,
      logo: 'https://public.readdy.ai/ai/img_res/7ed708d0-0e46-4404-b490-9c89f3f516ab.png',
      address: {
        '@type': 'PostalAddress',
        addressLocality: 'New York',
        addressRegion: 'NY',
        addressCountry: 'US',
      },
      geo: {
        '@type': 'GeoCoordinates',
        latitude: 40.7128,
        longitude: -74.006,
      },
      founder: {
        '@type': 'Person',
        name: 'Augustine Anyimadu-Ahenkae',
      },
      hasOfferCatalog: {
        '@type': 'OfferCatalog',
        name: 'K-12 Mathematics Curriculum',
        itemListElement: [
          { '@type': 'Offer', itemOffered: { '@type': 'Course', name: 'K-12 Mathematics Curriculum' } },
          { '@type': 'Offer', itemOffered: { '@type': 'Course', name: 'SAT Math & Reading Test Prep' } },
          { '@type': 'Offer', itemOffered: { '@type': 'Course', name: 'AP Calculus AB & BC' } },
          { '@type': 'Offer', itemOffered: { '@type': 'Course', name: 'AP Statistics' } },
        ],
      },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'Person',
      name: 'Augustine Anyimadu-Ahenkae',
      jobTitle: 'Mathematics Teacher',
      description:
        'NYC award-winning math teacher with 30+ years experience. Chancellor\'s Honor Award recipient offering comprehensive K-12 math instruction.',
      url: siteUrl,
      image: 'https://public.readdy.ai/ai/img_res/7ed708d0-0e46-4404-b490-9c89f3f516ab.png',
      worksFor: {
        '@type': 'EducationalOrganization',
        name: 'New York City Public Schools',
      },
      award: 'Chancellor\'s Honor Award',
      knowsAbout: [
        'K-12 Mathematics',
        'SAT Test Preparation',
        'AP Calculus',
        'Algebra',
        'Geometry',
        'Precalculus',
        'Statistics',
      ],
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="New York Mathematics Education | Augustine Anyimadu-Ahenkae | K-12 Math & Test Prep"
        description="Master mathematics with Augustine Anyimadu-Ahenkae, NYC's award-winning math teacher with 30+ years experience. Comprehensive K-12 curriculum, SAT, ACT test prep, and personalized tutoring. Chancellor's Honor Award recipient."
        canonical="/"
        keywords="mathematics education, math tutoring New York, SAT math prep, K-12 mathematics, Augustine Anyimadu-Ahenkae, AP Calculus, math teacher NYC"
        jsonLd={jsonLd}
      />
      <Navbar />
      <Hero />
      <VisualGrid />
      <FeaturedIn />
      <Testimonials />
      <TestimonialsCTA />
      <HonorsSection />
      <MembershipTiers />
      <FAQ />
      <LearningSystem />
      <PersonalTutoring />
      <FreeSection />
      <BooksSection />
      <TutoringForm />
      <ContactForm />
      <Footer />
      <FloatingBookButton />
    </div>
  );
}
